// Cờ môi trường cho phép `avatar doctor` BỎ QUA vòng hỏi phiên bản CLI phụ thuộc.
//
// Vì sao cần (đo 2026-09-17 trên chính máy dev, 3 lượt liên tiếp):
//   updateDependentClis   10 077 ms (lượt nguội) · 1 145 ms · 1 247 ms
//   detectSecurityScanners     6 ms ·     5 ms ·     6 ms
//   runChecks TỔNG        10 126 ms · 1 188 ms · 1 290 ms
// ⇒ vòng CLI phụ thuộc chiếm ~99,5% thời gian `doctor`. Nó spawn `brew --prefix`,
// `brew info --json=v2` cho 4 formula, `npm view` cho Claude Code, cộng `--version`
// từng binary — toàn thao tác chạm mạng/đĩa, vô nghĩa với test. Mỗi ca e2e gọi `doctor`
// phải trả nguyên khoản đó, và trên runner CI (cache nguội) là gần mức 10 s.
// Phần scanner 5-6 ms KHÔNG nằm trong phạm vi cờ này — cắt nó không đổi gì mà lại
// mù thêm một check.
//
// ⛔ Cờ này KHÁC `AVATAR_SKIP_TOOLING_ENSURE`, đừng gộp: cái kia gác đường **CÀI/UPDATE**
// (để CI không tự `npm i -g`), cờ này gác đường **ĐỌC phiên bản**. Một máy CI có thể
// muốn vế đầu mà vẫn cần vế sau, và ngược lại.
//
// ⚠️ Bật cờ KHÔNG được làm doctor im lặng: caller phải đẩy một check nói rõ đã bỏ qua
// (xem `doctor.ts`, cùng khuôn với `--no-probe`). Cảnh báo mất đi mà không ai biết thì
// đúng là thứ mà cả loạt ticket trước phải đi vá.

export const SKIP_DEPENDENT_CLI_CHECK_ENV = "AVATAR_SKIP_DEPENDENT_CLI_CHECK";

/**
 * Hàm THUẦN: nhận env, trả có bỏ qua hay không.
 *
 * Chỉ `"1"` và `"true"` (không phân biệt hoa thường, đã trim) mới bật. Cố ý KHÔNG dùng
 * phép "chuỗi rỗng là false" của JS: `AVATAR_SKIP_DEPENDENT_CLI_CHECK=0` hay `=false`
 * mà lại bật cờ là đúng lớp lỗi sentinel-string đã cắn trước đây — người đặt `=0` đang
 * nói KHÔNG.
 */
export function shouldSkipDependentCliCheck(env: NodeJS.ProcessEnv = process.env): boolean {
  const raw = env[SKIP_DEPENDENT_CLI_CHECK_ENV];
  if (typeof raw !== "string") return false;
  const normalized = raw.trim().toLowerCase();
  return normalized === "1" || normalized === "true";
}
